module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-campaign-page"
  }, [_c('v-container', {
    staticClass: "edit-campaign-devices-and-services"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.text) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "campaign-header-container"
  }, [_c('h3', {
    staticClass: "header-main py-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('OrganizationData.dashboard')))]), _vm._v(" " + _vm._s(_vm.organization))]), _vm._v(" "), _c('div', {
    staticClass: "campaign-selector-container"
  }, [(!_vm.isEditingCampaignName) ? _c('div', {
    staticClass: "campaign-name-display"
  }, [_c('p', {
    staticClass: "body-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('EditCampaign.service')))]), _vm._v("\n            " + _vm._s(_vm.selectedCampaign ? _vm.selectedCampaign.name : '') + "\n          ")]), _vm._v(" "), (_vm.selectedCampaign) ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "text": "",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": _vm.startEditingCampaignName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#00202F",
      "size": "16"
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "campaign-name-edit"
  }, [_c('v-text-field', {
    ref: "campaignNameInput",
    staticClass: "campaign-name-input",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "disabled": _vm.loadingCampaignName
    },
    on: {
      "blur": _vm.handleBlur,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveCampaignName.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEditingCampaignName.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.editedCampaignName),
      callback: function($$v) {
        _vm.editedCampaignName = $$v
      },
      expression: "editedCampaignName"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "loading": _vm.loadingCampaignName,
      "text": "",
      "fab": "",
      "x-small": "",
      "color": "success"
    },
    on: {
      "click": _vm.saveCampaignName
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "text": "",
      "fab": "",
      "x-small": "",
      "color": "error"
    },
    on: {
      "mousedown": _vm.cancelEditingCampaignName
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-close")])], 1)], 1)])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-4"
  }, [(_vm.isLoading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading && _vm.products.length === 0) ? _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "type": "info"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('EditCampaign.noProductsAvailable')) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.products.length > 0) ? _c('v-form', {
    ref: "devicesForm",
    staticClass: "action-row",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('div', [_vm._l((_vm.monitoringProducts), function(product, index) {
    return [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "body-text pointer",
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('monitoring', index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(product.quantity))]), _vm._v(" " + _vm._s(_vm.getProductDetailText(product)))]), _vm._v(" "), _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "text": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('monitoring', index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.monitoringProductsExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _vm._l((_vm.monitoringProductsData[index].devices), function(deviceInfo, deviceIndex) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.monitoringProductsExpanded[index]),
          expression: "monitoringProductsExpanded[index]"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.getDevices(deviceInfo.device, product.deviceType),
          "item-text": "campaign.entityName",
          "item-value": "id",
          "label": ((_vm.$t('EditCampaign.devicesAndServices.device')) + " *"),
          "title": _vm.$t('EditCampaign.devicesAndServices.device'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "required": "",
          "rules": [_vm.rules.fieldRequired],
          "hide-details": "auto",
          "hide-no-data": "",
          "disabled": !_vm.isStartDateEditable(deviceInfo.startDate)
        },
        on: {
          "change": function($event) {
            return _vm.handleSelectDevice()
          }
        },
        model: {
          value: (deviceInfo.instanceId),
          callback: function($$v) {
            _vm.$set(deviceInfo, "instanceId", $$v)
          },
          expression: "deviceInfo.instanceId"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("startDate-" + index),
              attrs: {
                "label": ((_vm.$t('EditCampaign.devicesAndServices.startDate')) + " *"),
                "title": _vm.$t('EditCampaign.devicesAndServices.startDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "rules": [_vm.rules.fieldRequired, function (v) { return _vm.rules.validateStartDate(v, index, deviceIndex); }],
                "hide-details": "auto",
                "disabled": !_vm.isStartDateEditable(deviceInfo.startDate),
                "append-icon": "mdi-calendar"
              },
              on: {
                "click:append": function($event) {
                  deviceInfo.startDateMenu = true
                }
              },
              model: {
                value: (deviceInfo.startDate),
                callback: function($$v) {
                  _vm.$set(deviceInfo, "startDate", $$v)
                },
                expression: "deviceInfo.startDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (deviceInfo.startDateMenu),
          callback: function($$v) {
            _vm.$set(deviceInfo, "startDateMenu", $$v)
          },
          expression: "deviceInfo.startDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleDeviceDateChange($event, deviceInfo, 'startDate')
          }
        },
        model: {
          value: (deviceInfo.auxStartDate),
          callback: function($$v) {
            _vm.$set(deviceInfo, "auxStartDate", $$v)
          },
          expression: "deviceInfo.auxStartDate"
        }
      })], 1)], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("endDate-" + index),
              attrs: {
                "label": ((_vm.$t('EditCampaign.devicesAndServices.endDate')) + " *"),
                "title": _vm.$t('EditCampaign.devicesAndServices.endDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "rules": [_vm.rules.fieldRequired, function (v) { return _vm.validateEndDateForDevice(v, deviceInfo, index); }],
                "hide-details": "auto",
                "append-icon": "mdi-calendar",
                "disabled": !deviceInfo.startDate || !_vm.isEndDateEditable(deviceInfo.endDate) || _vm.deviceHasExtension(index, deviceIndex)
              },
              on: {
                "click:append": function($event) {
                  deviceInfo.endDateMenu = true
                }
              },
              model: {
                value: (deviceInfo.endDate),
                callback: function($$v) {
                  _vm.$set(deviceInfo, "endDate", $$v)
                },
                expression: "deviceInfo.endDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (deviceInfo.endDateMenu),
          callback: function($$v) {
            _vm.$set(deviceInfo, "endDateMenu", $$v)
          },
          expression: "deviceInfo.endDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleDeviceDateChange($event, deviceInfo, 'endDate')
          }
        },
        model: {
          value: (deviceInfo.auxEndDate),
          callback: function($$v) {
            _vm.$set(deviceInfo, "auxEndDate", $$v)
          },
          expression: "deviceInfo.auxEndDate"
        }
      })], 1)], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.fields,
          "item-text": "name",
          "item-value": "id",
          "label": ((_vm.$t('EditCampaign.devicesAndServices.field')) + " *"),
          "title": _vm.$t('EditCampaign.devicesAndServices.field'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "required": "",
          "rules": [_vm.rules.fieldRequired],
          "hide-details": "auto",
          "disabled": !_vm.isStartDateEditable(deviceInfo.startDate)
        },
        model: {
          value: (deviceInfo.fieldInstanceId),
          callback: function($$v) {
            _vm.$set(deviceInfo, "fieldInstanceId", $$v)
          },
          expression: "deviceInfo.fieldInstanceId"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "4"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": ((_vm.$t('EditCampaign.devicesAndServices.coordinates')) + " *"),
          "title": _vm.$t('EditCampaign.devicesAndServices.coordinates'),
          "hint": _vm.$t('EditCampaign.devicesAndServices.coordinatesHint'),
          "background-color": "white",
          "outlined": "",
          "persistent-hint": "",
          "flat": "",
          "rules": [_vm.rules.fieldRequired, function (v) { return _vm.rules.validateLatLonForEditable(v, deviceInfo.startDate); }],
          "hide-details": "auto",
          "disabled": !_vm.isStartDateEditable(deviceInfo.startDate),
          "validate-on-blur": ""
        },
        model: {
          value: (deviceInfo.coordinates),
          callback: function($$v) {
            _vm.$set(deviceInfo, "coordinates", $$v)
          },
          expression: "deviceInfo.coordinates"
        }
      })], 1)], 1), _vm._v(" "), (deviceIndex < _vm.monitoringProductsData[index].devices.length - 1) ? _c('v-divider', {
        staticClass: "mt-2 mb-6"
      }) : _vm._e()], 1)
    })]
  }), _vm._v(" "), _vm._l((_vm.extensionProducts), function(product, index) {
    return [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "body-text pointer",
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('extension', index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(product.quantity))]), _vm._v(" " + _vm._s(_vm.getProductDetailText(product)))]), _vm._v(" "), _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "text": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('extension', index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.extensionProductsExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.extensionProductsExpanded[index]),
        expression: "extensionProductsExpanded[index]"
      }]
    }, [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "extension-description-text"
    }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.extensionProductsDescription')))])]), _vm._v(" "), _vm._l((_vm.extensionProductsData[index].extensions), function(extensionInfo, extensionIndex) {
      return _c('div', [(extensionIndex > 0) ? _c('v-divider', {
        staticClass: "my-2"
      }) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.getExtensionDevices(extensionInfo.device),
          "item-text": "campaign.entityName",
          "item-value": "id",
          "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.device')) + " *"),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.device'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "hide-details": "auto",
          "no-data-text": _vm.$t('NewCampaignInitialData.devicesAndServices.noDevices'),
          "rules": [function () { return _vm.validateExtensionDevice(extensionInfo); }],
          "disabled": extensionInfo.applied
        },
        model: {
          value: (extensionInfo.device),
          callback: function($$v) {
            _vm.$set(extensionInfo, "device", $$v)
          },
          expression: "extensionInfo.device"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "3"
        }
      }, [_c('v-select', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          "label": ("" + (_vm.$t('NewCampaignInitialData.devicesAndServices.unitsToExtend'))),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.unitsToExtend'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "hide-details": "auto",
          "rules": [function () { return _vm.validateUnitsToExtend(index); }]
        },
        model: {
          value: (extensionInfo.unitsToExtend),
          callback: function($$v) {
            _vm.$set(extensionInfo, "unitsToExtend", $$v)
          },
          expression: "extensionInfo.unitsToExtend"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("endDate-" + extensionIndex),
              attrs: {
                "label": ("" + (_vm.$t('NewCampaignInitialData.devicesAndServices.endDate'))),
                "title": _vm.$t('NewCampaignInitialData.devicesAndServices.endDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "hide-details": "auto",
                "append-icon": "mdi-calendar",
                "disabled": !extensionInfo.device || !_vm.isEndDateEditable(extensionInfo.endDate),
                "rules": [function () { return _vm.validateEndDateForExtension(extensionInfo.endDate, extensionInfo, index); }]
              },
              on: {
                "click:append": function($event) {
                  extensionInfo.endDateMenu = true
                }
              },
              model: {
                value: (extensionInfo.endDate),
                callback: function($$v) {
                  _vm.$set(extensionInfo, "endDate", $$v)
                },
                expression: "extensionInfo.endDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (extensionInfo.endDateMenu),
          callback: function($$v) {
            _vm.$set(extensionInfo, "endDateMenu", $$v)
          },
          expression: "extensionInfo.endDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleExtensionDateChange($event, extensionInfo, 'endDate')
          }
        },
        model: {
          value: (extensionInfo.auxEndDate),
          callback: function($$v) {
            _vm.$set(extensionInfo, "auxEndDate", $$v)
          },
          expression: "extensionInfo.auxEndDate"
        }
      })], 1)], 1), _vm._v(" "), (!extensionInfo.applied) ? _c('v-col', {
        attrs: {
          "align-self": "center"
        }
      }, [_c('a', {
        staticClass: "remove-extension-btn",
        on: {
          "click": function($event) {
            return _vm.removeExtension(index, extensionIndex)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.removeExtension')))])]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), (_vm.hasUnassignedExtensions(index)) ? _c('v-row', {
      staticClass: "mt-1",
      attrs: {
        "align": "baseline"
      }
    }, [_c('a', {
      staticClass: "add-extension-btn",
      on: {
        "click": function($event) {
          return _vm.addNewExtension(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.addNewExtension')))])]) : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-btn', {
    staticClass: "back-button",
    attrs: {
      "color": "#FFFFF"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('EditCampaign.devicesAndServices.back')))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "align": "start"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loading,
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('EditCampaign.devicesAndServices.finish')))])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7596342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/EditCampaignDevicesAndServices.vue
// module id = 1757
// module chunks = 0